module.exports = __webpack_public_path__ + "static/media/worry-1.434b485e.jpg";